export const validateMarkReadParams = (sessionId: string) => {
  if (!sessionId) {
    return new Error('A conversationId must be provided.');
  }

  return undefined;
};
